// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disabled-card[data-v-c5fb4196] {\n  opacity: 0.75;\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
